var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"research-report"},[_c('ReportRatings',{staticClass:"section-margin"}),_c('TargetPriceForecast',{staticClass:"section-margin"}),_c('ReportDigest')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }